import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PageRoutes } from '../../enums/enums';

export default function OpsTemporaryRedirectView() {
  const location = useLocation();
  const navigate = useNavigate();

  const pathArray = location.pathname.split('/').slice(2);
  const redirectArray = [PageRoutes.OPS_NEWS_OUTLET, 'nusbos', ...pathArray, location.search].filter(Boolean);
  navigate(`/${redirectArray.join('/')}`, { replace: true });

  return <></>;
}
